import { useEffect } from "react";
import { Moon, Sun } from "lucide-react";

export const DarkModeToggle = ({ darkMode, setDarkMode }) => {

    useEffect(()=>{
        localStorage.setItem("darkMode",JSON.stringify(darkMode))
    },[darkMode])

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={darkMode}
        onChange={() => setTimeout(() => setDarkMode(!darkMode), 350)}
        className="sr-only peer"
      />
      <div
        className={`w-10 h-5  rounded-full flex items-center p-1 transition-colors${
          darkMode ? " dark:bg-gray-700" : "  bg-gray-300"
        }`}
      >
        <div
          className={`w-7 h-7  flex  items-center justify-center rounded-full  shadow-md transition-transform duration-[600ms]  ${
            darkMode
              ? "bg-white translate-x-4"
              : "translate-x-[-10px] bg-gray-900 "
          }`}
        >
          {darkMode ? (
            <Sun className="w-4 h-4 text-yellow-500" />
          ) : (
            <Moon className="w-4 h-4 text-gray-300" />
          )}
        </div>
      </div>
    </label>
  );
};
